import classNames from 'classnames';
import styles from './header.module.css';
import { ReactNode, useEffect, useState } from 'react';
import logo from '../../assets/images/logo.png';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import translations from '../translations';
import MenuComponent from '../menu/Menu';
import pt from "../../assets/flags/portugal.svg"
import eng from "../../assets/flags/united-kingdom.svg"

const MainHeader: React.FC = () => {
  const { pathname, search } = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [languageLabel, setLanguageLabel] = useState<{ lang: string; icon: ReactNode; }>({ lang: 'pt', icon: <img style={{ width: 16, height: 16 }} src={pt} /> });
  const { selectedLanguage, setSelectedLanguage } = useLanguage();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [window.innerWidth]);

  const handleLanguageChange = (lang: 'pt' | 'en', icon: any) => {
    setSelectedLanguage(lang)
    setLanguageLabel({ lang: lang.toLocaleUpperCase(), icon: icon });
  };

  return (
    <div className={styles.mainHeader}>
      <nav className={styles.navbar}>
        <div className={styles.navbar_container}>
          <div className={styles.navbar_brand_container}>
            <div className={styles.navbar_brand}>
              <Link to="/">
                <img src={logo} alt="Logo" />
              </Link>
              <span>
                {translations[selectedLanguage].weatherPortal}
                <br />
                <small>{translations[selectedLanguage].weatherForecast}</small>
              </span>
            </div>

            <button
              onClick={() => setIsOpen(true)}
              className={classNames("navbar-toggler", styles.navbar_toggle)}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#mynavbar"
            >
              <i className="fas fa-bars"></i>
            </button>
          </div>

          {isOpen && <div className={styles.overlay}></div>}
          <div className={`${styles.navbar_menu} ${isOpen ? `${styles.navbar_menu_open}` : ''}`}>
            {isOpen && (
              <span onClick={() => setIsOpen(false)} className={styles.toggle_icon_close}>
                ✖
              </span>
            )}
            <a href="#" className={classNames(styles.navbar_link, pathname === "/home" ? styles.active : "")}>
              {translations[selectedLanguage].home}
            </a>
            <a href="#" className={styles.navbar_link}>
              {translations[selectedLanguage].contacts}
            </a>

            <span className={styles.navbar_link}>
              <MenuComponent
                label={<span className={styles.languageSelector}>
                  <span style={{ width: 50, display: "flex", gap: 5 }}>
                    {languageLabel?.icon}{languageLabel?.lang.toUpperCase()}
                  </span>
                </span>}
                menuItems={[
                  { label: `Pt`, icon: <img style={{ width: 16, height: 16 }} src={pt} />, onClick: () => handleLanguageChange('pt', <img style={{ width: 16, height: 16 }} src={pt} />) },
                  { label: `Eng`, icon: <img src={eng} style={{ width: 16, height: 16 }} />, onClick: () => handleLanguageChange('en', <img src={eng} style={{ width: 16, height: 16 }} />) }
                ]}
              />
            </span>

            <Link to={`/login${search}`} className={classNames(styles.navbar_link)}>
              {translations[selectedLanguage].login}
              <i className="fas fa-sign-in-alt"></i>
            </Link>
          </div>
        </div>
      </nav>
    </div>
  );
};

export { MainHeader };
